import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;

//登录
export function login(data) {
  return fetch({
    url: apiUrl + '/api/UserContext/Login',
    method: 'post',
    data,
    noToken:true
  })
}

//登出
export function logout() {
  return fetch({
    url: apiUrl + '/api/UserContext/Logout',
    method: 'post'
  })
}

//忘记密码重置密码
export function resetPassword(data){
  return axios({
    url: apiUrl + '/api/UserContext/ResetPassword',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/userContextApi.js